
import dateFormat from 'vux/src/tools/date/format.js'

import {
apiUrl,
apiParams
} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
name: "FeeMaintainList",
components: {
MyBtnReturn
},
mounted() {
this.$refs.scrollerBottom.reset()
},
data() {
const pulldownDefaultConfig = {
content: '下拉刷新',
height: 60,
autoRefresh: true,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
};
const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: true,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
};
return {
src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的图片
src2: require('@/assets/images/plan/wx_chai_oringe.png'), // 拆箱的图片
tableData: [],
scrollerStatus: {
pulldownStatus: 'default',
pullupStatus: 'enabled'
},
pageNo: 1, // 页码
pullupDefaultConfig: pullupDefaultConfig,
pulldownDefaultConfig: pulldownDefaultConfig
}
},
created() {
document.title = '费用维护';
this.onPulldownLoading()
},
methods: {
getData() {
let data = {
openId: apiParams.openId,
companyId: apiParams.companyId,
code: apiParams.code,
pageNo: this.pageNo,
pageSize: 10
};
this.requestApi({
url: apiUrl.feeMaintainPageList,
data: data
}, (resultData) => {
let list = resultData.data.page.result || [];

this.tableData.push.apply(this.tableData, list);

this.scrollerStatus.pulldownStatus = 'default';
let totalPages = resultData.data.page.totalPages;
if (this.pageNo >= totalPages) {
this.scrollerStatus.pullupStatus = 'disabled'
} else {
this.scrollerStatus.pullupStatus = 'default'
}

this.$refs.scrollerBottom.reset()

}, (error) => {
if (error) {
this.scrollerStatus.pulldownStatus = 'default';
this.scrollerStatus.pullupStatus = 'default'
}
})
},
goReportContNo(ladingId, otherservice, bookingId) {
this.$router.push({
name: 'FeeMaintain',
query: {
ladingId: ladingId,
otherservice: otherservice,
bookingId: bookingId
}
})
},
dateFormat(time) {
return dateFormat(time, 'YYYY-MM-DD HH:mm')
},
/**
* 下拉刷新
*/
onPulldownLoading() {
this.pageNo = 1;
this.tableData = [];
this.getData()
},
/**
* 上拉加载更多
*/
onPullupLoading() {
this.pageNo++;
this.getData()
}
}
}



// WEBPACK FOOTER //
// ./src/components/siji/feeMaintain/FeeMaintainList.vue